import { render, staticRenderFns } from "./RankingLoading.vue?vue&type=template&id=0e49a1c5"
import script from "./RankingLoading.vue?vue&type=script&lang=ts"
export * from "./RankingLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports